/**
 * Optional token refresh hook for pro-api requests (registered from AuthProvider).
 */
let tokenRefreshHandler: (() => Promise<string | null>) | null = null;

export function setProApiTokenRefreshHandler(
  handler: (() => Promise<string | null>) | null,
): void {
  tokenRefreshHandler = handler;
}

export async function refreshAccessTokenForProApi(): Promise<string | null> {
  if (!tokenRefreshHandler) return null;
  return tokenRefreshHandler();
}
